import React, { useState, useEffect, useRef } from 'react'
import { AppleStore, BannerVideo, Customer, MobileNew, NewLogo, Partner, Playstore, Star, VideoPoster, WhiteArw } from '../assets/ExportImageIcon'
import { Link } from 'react-router-dom'
import Seo from '../components/Seo'
import "./promotional.css"

const useCountUp = (target, started, duration = 2000) => {
  const [count, setCount] = useState(0)

  useEffect(() => {
    if (!started) return
    let startTime = null
    const raf = requestAnimationFrame(function step(timestamp) {
      if (!startTime) startTime = timestamp
      const progress = Math.min((timestamp - startTime) / duration, 1)
      setCount(Math.floor(progress * target))
      if (progress < 1) requestAnimationFrame(step)
    })
    return () => cancelAnimationFrame(raf)
  }, [started, target, duration])

  return count
}

const SUBSCRIBE_URL = 'https://api-staging.sabraah.com/api/v1/subscriptions/mail/subscribe'
const API_KEY = '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'

const HOME_JSON_LD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://sabraah.com/#organization",
      "name": "SabRaah",
      "alternateName": "SabRaah",
      "url": "https://sabraah.com/",
      "logo": "https://sabraah.com/favicon.webp",
      "description": "AI-powered personalized travel platform helping travelers discover flights, hotels, car rentals, cruises, events, entertainment, and unique travel experiences.",
      "sameAs": [
        "https://www.instagram.com/_sabraah_/",
        "https://x.com/_sabraah_",
        "https://www.facebook.com/people/Sabraah/61591311878312/",
        "https://www.linkedin.com/company/sabraah/",
        "https://www.youtube.com/@sabraah_official"
      ]
    },
    {
      "@type": "WebSite",
      "@id": "https://sabraah.com/#website",
      "url": "https://sabraah.com/",
      "name": "SabRaah",
      "alternateName": "SabRaah",
      "description": "AI-powered personalized travel platform for global travel experiences.",
      "publisher": {
        "@id": "https://sabraah.com/#organization"
      },
      "inLanguage": "en"
    }
  ]
}

const Promotional = () => {
  const sectionRef = useRef(null)
  const [started, setStarted] = useState(false)
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [feedback, setFeedback] = useState({ msg: '', type: '' })

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setStarted(true) },
      { threshold: 0.3 }
    )
    if (sectionRef.current) observer.observe(sectionRef.current)
    return () => observer.disconnect()
  }, [])

  const videoRef = useRef(null)

  const setVideoRef = (el) => {
    if (!el) return
    videoRef.current = el
    el.muted = true
    el.defaultMuted = true
    el.setAttribute('muted', '')
    el.setAttribute('playsinline', '')
  }

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    const tryPlay = () => video.play().catch(() => {})

    tryPlay()

    video.addEventListener('loadedmetadata', tryPlay, { once: true })
    video.addEventListener('canplay', tryPlay, { once: true })

    document.addEventListener('touchstart', tryPlay, { once: true })
    document.addEventListener('click', tryPlay, { once: true })

    return () => {
      document.removeEventListener('touchstart', tryPlay)
      document.removeEventListener('click', tryPlay)
    }
  }, [])

  const travelers = useCountUp(1, started)
  const partners = useCountUp(500, started)

  const handleSubscribe = async () => {
    if (!email.trim()) {
      setFeedback({ msg: 'Please enter your email address.', type: 'error' })
      return
    }
    setLoading(true)
    setFeedback({ msg: '', type: '' })
    try {
      const res = await fetch(SUBSCRIBE_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${API_KEY}`,
        },
        body: JSON.stringify({ email }),
      })
      const data = await res.json()
      if (data.status === 'success') {
        const already = data.data?.is_subscribed && data.message?.toLowerCase().includes('already')
        setFeedback({
          msg: already ? 'You are already subscribed!' : 'Successfully subscribed!',
          type: 'success',
        })
        if (!already) setEmail('')
      } else {
        setFeedback({ msg: data.message || 'Something went wrong.', type: 'error' })
      }
    } catch {
      setFeedback({ msg: 'Network error. Please try again.', type: 'error' })
    } finally {
      setLoading(false)
    }
  }

  
  return (
    <>
        <Seo
          title="SabRaah | AI-Powered Personalized Travel Platform for Global Experiences"
          description="Plan smarter journeys with SabRaah's AI-powered travel platform. Discover personalized flights, hotels, car rentals, cruises, events, entertainment, and unforgettable experiences, all in one place."
          path="/"
          jsonLd={HOME_JSON_LD}
        />

        <section className='promotionalBanner'>
                <video poster={VideoPoster} 
                // autoplay="" loop="" muted="" playsinline=""
                ref={setVideoRef}
                className='promoBanner'
                // autoPlay
                // muted
                // loop
                // playsInline
                // preload="auto"
                // onCanPlay={() => videoRef.current?.play().catch(() => {})}
                // onLoadedMetadata={() => videoRef.current?.play().catch(() => {})}
                loop muted="" playsinline="" data-object-fit="cover" preload="metadata"
                >
                <source src={BannerVideo} type="video/mp4" />
            </video>
            {/* <video
                ref={setVideoRef}
                className='promoBanner'
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                onCanPlay={() => videoRef.current?.play().catch(() => {})}
                onLoadedMetadata={() => videoRef.current?.play().catch(() => {})}
            >
                <source src={BannerVideo} type="video/mp4" />
            </video> */}
            {/* <img src={BannerPromotional} className='promoBanner' /> */}
            <div className='container'>
                <div className='row'>
                    {/* <div className='col-md-12'>
                        <div className='logo'>
                            <img src={Logo} alt='Logo'/>
                        </div>
                    </div> */}
                    <div className='col-lg-6 col-md-6'>
                        <div className='content'>
                            <div className='logo'>
                                <img src={NewLogo} alt='SabRaah'/>
                            </div>
                            <div className='note'><img src={Star} alt='Star'/> India's next generation AI powered Super App is Coming Soon!</div>
                            <div className='bigText'>Explore Without <span className='textGreen'>Limits.</span></div>
                            <p>Book Flights, Hotels, Trains, Events, Experiences and more across the globe, all in one seamless platform</p>
                            <div className='stores'>
                                <Link to=""><img src={Playstore} alt='Play Store'/></Link>
                                <Link to=""><img src={AppleStore} alt='Apple Store'/></Link>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-6 col-md-6'>
                        <div className='imgPart'>
                            <img src={MobileNew} alt='Mobile Logo' />
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className='counts' ref={sectionRef}>
            <div className='container'>
                <div className='countsInner'>
                    <div className='row'>
                        <div className='col-md-4'>
                            <div className='data'>
                                <img src={Customer} alt='Customer'/>
                                <div>
                                    <div className='text1'>{travelers}K</div>
                                    <div className='text2'>Happy Travelers</div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='data'>
                                <img src={Partner} alt='Partner'/>
                                <div>
                                    <div className='text1'>{partners}+</div>
                                    <div className='text2'>Travel Partners</div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='data'>
                                <img src={Customer} alt='Customer'/>
                                <div>
                                    <div className='text1'>24/7</div>
                                    <div className='text2'>Customer Support</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className='subscribe'>
            <div className='container'>
                <div className='row g-4'>
                    <div className='col-md-12'>
                        <div className='heading textGreen'>subscribe</div>
                        <div className='heading2'>To Get Exclusive Updates</div>
                        <p>Subscribe to our newsletter and get exclusive deals you wont find anywhere else straight to your inbox!</p>

                        <div className='subInputWrap'>
                            <div className='subInput'>
                                <input
                                    type='email'
                                    placeholder='Enter Email Address'
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleSubscribe()}
                                    disabled={loading}
                                />
                                <button onClick={handleSubscribe} disabled={loading}>
                                    {loading ? 'Subscribing...' : <> Subscribe <img src={WhiteArw} alt='Arrow'/> </>}
                                </button>
                            </div>
                            {feedback.msg && (
                                <div className={`subFeedback ${feedback.type}`}>
                                    {feedback.msg}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <footer>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='footerLinks'>
                             <Link to="mailto:subscribe@sabraah.com">
                                contact us - subscribe@sabraah.com
                            </Link>
                            <div className='privacyLink'>
                                <Link to="/">Home</Link>
                                |
                                <Link to="/about-us">About Us</Link>
                                |
                                <Link to="/privacy-policy">Privacy Policy</Link>
                                |
                                <Link to="/terms-conditions">Terms & Conditions</Link>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </footer>
    </>
  )
}

export default Promotional
